export enum SeFields {
    DOMAINS = 'domaineSki',
    STATION = 'station',
    PARENT_STATION = 'parentStation',
    REGION = 'region'
}
